import PropTypes from "prop-types";

const TopBar = {
	flipVisible: PropTypes.bool,
};

export default {
	TopBar,
};
